import React from 'react'

const Label = (props) => {
  const { htmlFor, children } = props
  return (
    <label className='label app-label' htmlFor={htmlFor}>{children}</label>
  )
}

export default Label



// WEBPACK FOOTER //
// ./src/components/generic/Label.js